import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function TermsPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white" data-testid="terms-page">
      <div className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-gray-200">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <h1 className="text-lg font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>Terms of Service</h1>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-6 py-10 prose prose-sm">
        <h1 style={{ fontFamily: 'Outfit, sans-serif' }}>Terms of Service</h1>
        <p><strong>Last updated:</strong> March 12, 2026</p>
        <p>Welcome to Gloverse. By using our Service, you agree to these Terms. Please read them carefully.</p>

        <h2>1. Acceptance of Terms</h2>
        <p>By accessing or using Gloverse (gloverse.in), you agree to be bound by these Terms of Service and our Privacy Policy.</p>

        <h2>2. Your Account</h2>
        <ul>
          <li>You must provide accurate information when creating an account.</li>
          <li>You are responsible for maintaining the security of your account.</li>
          <li>You must be at least 13 years old to use the Service.</li>
        </ul>

        <h2>3. Content You Create</h2>
        <ul>
          <li>You retain ownership of content you post on Gloverse (photos, checklists, Looks).</li>
          <li>By posting, you grant Gloverse a non-exclusive license to display, distribute, and promote your content on the platform.</li>
          <li>You must not post content that is illegal, harmful, or infringes on others' rights.</li>
        </ul>

        <h2>4. Product Checklists</h2>
        <ul>
          <li>Checklists are user-generated product recommendations, not endorsements by Gloverse.</li>
          <li>Gloverse does not guarantee the accuracy of product information, prices, or availability.</li>
          <li>Purchase links redirect to third-party websites; Gloverse is not responsible for transactions on those sites.</li>
        </ul>

        <h2>5. Glow Badge</h2>
        <ul>
          <li>The Glow Badge is a verification mark for creators, awarded at Gloverse's discretion.</li>
          <li>Gloverse reserves the right to revoke badges for violations of these Terms.</li>
        </ul>

        <h2>6. Prohibited Conduct</h2>
        <ul>
          <li>Impersonating others or creating fake accounts</li>
          <li>Posting misleading product information</li>
          <li>Spamming, harassing, or abusing other users</li>
          <li>Attempting to manipulate engagement metrics</li>
          <li>Scraping or automated access without permission</li>
        </ul>

        <h2>7. Termination</h2>
        <p>We may suspend or terminate your account for violations of these Terms, at our sole discretion.</p>

        <h2>8. Limitation of Liability</h2>
        <p>Gloverse is provided "as is" without warranties. We are not liable for any damages arising from your use of the Service.</p>

        <h2>9. Changes to Terms</h2>
        <p>We may update these Terms from time to time. Continued use of the Service constitutes acceptance of the updated Terms.</p>

        <h2>10. Contact</h2>
        <p>Questions? Contact us at <strong>info@gloverse.in</strong>.</p>
      </div>
    </div>
  );
}
